import React, { useEffect } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import NotificationProvider from "./contexts/NotificationContext";
import Routes from "./Routes";
import reviewArchiveScheduler from "./utils/reviewArchiveScheduler";

function App() {
  useEffect(() => {
    // Automatic archiving disabled per new moderation flow
    // reviewArchiveScheduler.start(24);

    // Cleanup on app unmount
    return () => {
      // reviewArchiveScheduler.stop();
    };
  }, []);

  return (
    <AuthProvider>
      <SidebarProvider>
        <OrganizationProvider>
          <NotificationProvider>
          <Routes />
          </NotificationProvider>
        </OrganizationProvider>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;